module.exports = __webpack_public_path__ + "img/calendar-22_fill.25d5bcbe.svg";